const positiveCompanyId = (value) => {
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};

// L'état reçu pour une entreprise ne doit pas verrouiller les autres entreprises
// auxquelles le même utilisateur est autorisé à accéder.
export const isSubscriptionPortalOnlyForCompany = (user, selectedCompany) => {
  if (!user) return false;
  const access = user.subscription_access;
  const accessCompanyId = positiveCompanyId(access?.company_id);
  const currentCompanyId = positiveCompanyId(selectedCompany) ||
    positiveCompanyId(user.company_id);
  if (!accessCompanyId || !currentCompanyId) {
    return Boolean(user.subscription_portal_only);
  }
  return accessCompanyId === currentCompanyId &&
    Boolean(access.restriction_enforced) &&
    access.access_state === 'suspended';
};
